module.exports = __webpack_public_path__ + "img/plus_icon.9ceca0ce.png";